import { render, staticRenderFns } from "./cuenta_por_pagar.vue?vue&type=template&id=32cb6426&lang=pug&"
import script from "./cuenta_por_pagar.vue?vue&type=script&lang=js&"
export * from "./cuenta_por_pagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports